module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/qr_android-ba27eaf2a722d429df767afcc0db72d5.png";